import React from 'react';
import PageRow from '../PageRow/PageRow';
import Ingress from '../../Typography/Ingress/Ingress';
import { CreateProps } from '../../../types/utils/CreateProps';

type PageIngressProps = CreateProps<
  {
    /** To make the ingress narrow */
    narrow?: boolean;
  },
  typeof Ingress
>;

const PageIngress: React.FunctionComponent<PageIngressProps> = ({
  children,
  narrow,
  ...props
}) => {
  return (
    <PageRow
      narrow={narrow}
      margin={false}
      responsiveFullWidth={narrow}
      hasPanel={false}
    >
      <Ingress margin={{ bottom: 'sm' }} {...props}>
        {children}
      </Ingress>
    </PageRow>
  );
};

export default PageIngress;
